export interface ProductLabel {
  id: string;
  name: string;
  color: string;
  blocks_purchase: boolean;
  default_message: string | null;
}

export interface ProductLabelFields {
  labels?: ProductLabel[];
  purchaseBlocked?: boolean;
  unavailableMessage?: string | null;
}

export const DEFAULT_UNAVAILABLE_MESSAGE = 'Ten produkt jest obecnie niedostępny. Zapraszamy do wyboru innego produktu.';

/** Product-level restrictions take precedence over the selected variant's stock. */
export function productUnavailableReason(
  product: ProductLabelFields | null | undefined,
  variant?: { availableForSale: boolean } | null,
): string | null {
  const blockingLabel = product?.labels?.find(label => label.blocks_purchase);
  if (product?.purchaseBlocked || blockingLabel) {
    return product?.unavailableMessage?.trim() || blockingLabel?.default_message?.trim() || DEFAULT_UNAVAILABLE_MESSAGE;
  }
  if (variant && !variant.availableForSale) {
    return 'Wybrany wariant jest chwilowo niedostępny. Wybierz inny wariant produktu.';
  }
  return null;
}

export function productLabelColors(color: string): { background: string; color: string; borderColor: string } {
  const accent = /^#[\da-f]{6}$/i.test(color) ? color : '#b74779';
  const rgb = [1, 3, 5].map(start => parseInt(accent.slice(start, start + 2), 16));
  const mixWithWhite = (amount: number) => rgb.map(channel => Math.round(channel + (255 - channel) * amount));
  const hex = (channels: number[]) => `#${channels.map(channel => Math.round(channel).toString(16).padStart(2, '0')).join('')}`;
  const luminance = (channels: number[]) => channels.map(channel => channel / 255)
    .map(value => value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4)
    .reduce((sum, value, index) => sum + value * [0.2126, 0.7152, 0.0722][index], 0);
  const background = mixWithWhite(0.93);
  let ink = [...rgb];
  // Preserve the chosen hue while keeping even pale custom colors readable.
  while ((luminance(background) + 0.05) / (luminance(ink) + 0.05) < 4.8) {
    ink = ink.map(channel => Math.floor(channel * 0.9));
  }
  return { background: hex(background), color: hex(ink), borderColor: hex(mixWithWhite(0.77)) };
}
